module.exports = __webpack_public_path__ + "img/fotometro.99be953b.webp";